// import then needed Font Awesome functionality
import fontawesome from '@fortawesome/fontawesome';

// Import icons
import {
    faFacebook,
    faFacebookF,
    faFacebookSquare,
    faTwitter,
    faTwitterSquare,
    faLinkedin,
    faLinkedinIn,
    faInstagram,
    faInstagramSquare,
    faYoutube,
    faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';

import {
    faPlus,
    faMinus,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCaretDown,
    faCircle,
    faBriefcase,
    faPhone,
    faEnvelope,
    faSquareFull,
    faDownload,
    faLocationDot,
    faCalendarCheck,
    faLink,
    faTag,
    faGraduationCap,
} from '@fortawesome/free-solid-svg-icons';
// import { faUserCircle } from '@fortawesome/free-regular-svg-icons';

// add the imported icons to the library
fontawesome.config.searchPseudoElements = true

fontawesome.library.add(
    faPlus,
    faMinus,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCaretDown,
    faCircle,
    faFacebook,
    faFacebookF,
    faFacebookSquare,
    faTwitter,
    faTwitterSquare,
    faLinkedin,
    faLinkedinIn,
    faInstagram,
    faInstagramSquare,
    faYoutube,
    faYoutubeSquare,
    faBriefcase,
    faPhone,
    faEnvelope,
    faSquareFull,
    faDownload,
    faLocationDot,
    faCalendarCheck,
    faLink,
    faTag,
    faGraduationCap,
    {
      prefix: 'fas',
      iconName: 'email',
      icon: [
        21,
        16,
        [],
        'f0e01',
        'M1.07273 2.14936C1.30044 2.04668 1.58386 2 1.92353 2H19.9176C20.2446 2 20.5142 2.04917 20.7364 2.14936L11.4262 9.21426C11.0484 9.38629 10.7607 9.38629 10.3829 9.21426L1.07273 2.14936ZM0.5 3.43995C0.5 3.23793 0.527539 3.05534 0.572246 2.89552L7.18182 8.00645L0.604077 13.2836C0.535766 13.0988 0.5 12.8821 0.5 12.6333V3.43995ZM21.4358 2.89552L14.8182 8.00639L21.3959 13.2836C21.4653 13.0942 21.5 12.8681 21.5 12.6107V3.41724C21.5 3.22451 21.4784 3.04985 21.436 2.89561L21.4358 2.89552ZM7.90594 8.6269L7.90599 8.62687H7.9059C7.90591 8.62688 7.90593 8.62689 7.90594 8.6269ZM7.90594 8.6269L1.26364 13.8958C1.46851 13.9659 1.71468 14 1.99736 14H19.8438C20.1119 14 20.3481 13.9631 20.5455 13.8958L13.9026 8.62687C13.6563 8.81213 13.4083 9.00106 13.1599 9.19027C12.7392 9.5107 12.3175 9.83194 11.9011 10.1375C11.269 10.4325 10.5396 10.4325 9.90749 10.1375C9.42812 9.7876 8.94736 9.42071 8.46851 9.05527C8.28063 8.91189 8.09304 8.76873 7.90594 8.6269Z',
      ],
    },
    {
      prefix: 'fas',
      iconName: 'pencil',
      icon: [
        15,
        15,
        [],
        'f0e02',
        'M12.7397 6.51066L8.48939 2.26044L10.6095 0.140128C10.7963 -0.0467094 11.0991 -0.0467094 11.2858 0.140128L14.8599 3.71421C15.0467 3.9009 15.0467 4.20363 14.8599 4.39047L12.7397 6.51066ZM0.00668947 14.443L0.746695 10.0031L7.13648 3.61301L11.3872 7.86323L4.997 14.2533L0.55697 14.9933C0.233232 15.0473 -0.0472647 14.7666 0.00668947 14.443Z',
      ],
    },
    {
      prefix: 'fas',
      iconName: 'map-marker',
      icon: [
        12,
        15,
        [],
        'f0e03',
        'M6.09265 0.143555C7.81842 0.143555 9.42092 0.930912 10.4687 2.31903C11.9684 4.30804 11.9684 7.06365 10.4687 9.05266L6.09265 14.8125L1.7166 9.05266C0.216864 7.06365 0.216864 4.30804 1.7166 2.31903C2.76438 0.930912 4.36688 0.143555 6.09265 0.143555ZM8.96878 5.78687C8.96878 4.17433 7.67484 2.85498 6.09328 2.85498C4.51175 2.85498 3.21777 4.17433 3.21777 5.78687C3.21777 7.3994 4.51175 8.71875 6.09328 8.71875C7.6748 8.71875 8.96878 7.3994 8.96878 5.78687Z',
      ],
    },
    {
      prefix: 'fas',
      iconName: 'people',
      icon: [
        18,
        13,
        [],
        'f0e04',
        'M9.00023 4.33336C10.1836 4.33336 11.143 3.3633 11.143 2.1666C11.143 0.970055 10.1836 0 9.00023 0C7.81682 0 6.85742 0.970055 6.85742 2.1666C6.85742 3.3633 7.81682 4.33336 9.00023 4.33336ZM14.3414 8.43413C14.7433 8.02817 15.2884 7.7998 15.8568 7.7998C16.4251 7.7998 16.9702 8.02816 17.3723 8.43413C17.7738 8.84065 17.9996 9.39185 17.9996 9.96641V11.6998C17.9996 12.0447 17.8642 12.3753 17.623 12.6189C17.382 12.8628 17.055 12.9998 16.7139 12.9998H14.9996C14.6585 12.9998 14.3315 12.8628 14.0907 12.6189C13.8493 12.3753 13.7139 12.0447 13.7139 11.6998V9.96641C13.7139 9.39185 13.9397 8.84065 14.3414 8.43413ZM4.28576 9.96641C4.28576 9.39185 4.0599 8.84065 3.65826 8.43413C3.25635 8.02816 2.7112 7.7998 2.14281 7.7998C1.57456 7.7998 1.02942 8.02817 0.627355 8.43413C0.225845 8.84065 0 9.39185 0 9.96641V11.6998C0 12.0447 0.135459 12.3753 0.376678 12.6189C0.617606 12.8628 0.944633 12.9998 1.28571 12.9998H3.00005C3.34114 12.9998 3.66818 12.8628 3.90894 12.6189C4.1503 12.3753 4.28576 12.0447 4.28576 11.6998V9.96641ZM5.51926 12.6193C5.27804 12.3757 5.14258 12.045 5.14258 11.7002V9.10017C5.14258 6.94605 6.86926 5.2002 8.99972 5.2002C10.0227 5.2002 11.0038 5.61096 11.7271 6.34248C12.4506 7.07386 12.8569 8.06582 12.8569 9.10017V11.7002C12.8569 12.045 12.7214 12.3757 12.4802 12.6193C12.2393 12.8632 11.9122 13.0002 11.5711 13.0002H6.42829C6.08721 13.0002 5.76018 12.8632 5.51926 12.6193ZM3.42885 5.63349C3.42885 6.35138 2.85329 6.93348 2.14314 6.93348C1.43313 6.93348 0.857422 6.35138 0.857422 5.63349C0.857422 4.91545 1.43313 4.3335 2.14314 4.3335C2.85329 4.3335 3.42885 4.91545 3.42885 5.63349ZM15.857 6.93348C16.567 6.93348 17.1427 6.35138 17.1427 5.63349C17.1427 4.91545 16.567 4.3335 15.857 4.3335C15.1468 4.3335 14.5713 4.91545 14.5713 5.63349C14.5713 6.35138 15.1468 6.93348 15.857 6.93348Z',
      ],
    },
    {
      prefix: 'fas',
      iconName: 'euro',
      icon: [
        13,
        12,
        [],
        'f0e04',
        'M7.08816 9.54799C7.69616 9.54799 8.2295 9.41465 8.68816 9.14799C9.14683 8.88132 9.5095 8.49199 9.77616 7.97999H12.3362C11.9628 9.12132 11.3068 10.012 10.3682 10.652C9.44016 11.2813 8.35216 11.596 7.10416 11.596C5.82416 11.596 4.69883 11.2547 3.72816 10.572C2.76816 9.87866 2.1015 8.95599 1.72816 7.80399H0.368164V6.47599H1.47216C1.45083 6.21999 1.44016 6.02799 1.44016 5.89999C1.44016 5.75065 1.45083 5.54799 1.47216 5.29199H0.368164V3.96399H1.74416C2.1175 2.81199 2.78416 1.89465 3.74416 1.21199C4.71483 0.529322 5.83483 0.187988 7.10416 0.187988C8.35216 0.187988 9.44016 0.507988 10.3682 1.14799C11.3068 1.78799 11.9628 2.67332 12.3362 3.80399H9.77616C9.5095 3.29199 9.14683 2.90799 8.68816 2.65199C8.2295 2.38532 7.69616 2.25199 7.08816 2.25199C6.4375 2.25199 5.85616 2.40132 5.34416 2.69999C4.84283 2.99865 4.4535 3.41999 4.17616 3.96399H7.24816V5.29199H3.77616C3.75483 5.54799 3.74416 5.75065 3.74416 5.89999C3.74416 6.02799 3.75483 6.21999 3.77616 6.47599H7.24816V7.80399H4.16016C4.4375 8.34799 4.83216 8.77465 5.34416 9.08399C5.85616 9.39332 6.4375 9.54799 7.08816 9.54799Z',
      ],
    }
);



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js